import Head from 'next/head'
import React from 'react'
import AdaptiveThemeBox from '@/atoms/AdaptiveThemeBox'
import HugeTitle from '@/atoms/LargeTitle'
import ThemeBox from '@/atoms/ThemeBox'
import ThemedBackground from '@/atoms/ThemedBackground'
import { attributes } from '@/content/responsive_disclosure.md'
import { ResponsiveDisclosure as ResponsiveDisclosureType } from '@/content/types'
import { useLocale } from '@/hooks/useLocale'
import Footer from '@/organisms/Footer'
import HeaderBar from '@/organisms/HeaderBar'
import MetaInformation from '@/utils/MetaInformation'
import Container from '@/molecules/Container'
import LegalContent from '@/organisms/LegalContent'

export default function ResponsiveDisclosure() {
  const { translations, locale } =
    useLocale<ResponsiveDisclosureType>(attributes)

  return (
    <>
      <Head>
        <title>{translations.meta.title}</title>
        <MetaInformation locale={locale} {...translations.meta} />
      </Head>
      <AdaptiveThemeBox defaultTheme="bright">
        <HeaderBar />
      </AdaptiveThemeBox>
      <ThemeBox theme="bright">
        <ThemedBackground>
          <Container>
            <div className="my-12 max-w-prose mx-auto">
              <HugeTitle>{translations.page_title}</HugeTitle>
              <LegalContent content={translations.content} />
            </div>
          </Container>
        </ThemedBackground>
      </ThemeBox>
      <ThemeBox theme="black">
        <Footer />
      </ThemeBox>
    </>
  )
}
